// extracted by mini-css-extract-plugin
export default {"trigger":"trigger--jAZks"};